/**
 * Toggle the value of a boolean.
 */
export const toggle = (x: boolean): boolean => !x;
